import React from 'react';
import './styles/Contact.css';


function Contact() {
    return (
        <div className="contact-container">
            <h1 className="contact-title">Contact Us</h1>
            <p className="contact-description">
                For any inquiries or more information about our team and research, please feel free to reach out.
            </p>
            <div className="contact-info">
                <h2 className="contact-supervisor">Principal Supervisor</h2>
                <p className="contact-name">Caterina Giannetti</p>
                <p className="contact-email">
                    Email: <a href="mailto:caterina.giannetti@gmail.com">caterina.giannetti@gmail.com</a>
                </p>
            </div>
        </div>

    );
}

export default Contact;